import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import SecurityPlugin from '@agrial/vue-plugin-security';
import vuetify from './plugins/vuetify';
import AxiosConfig from './plugins/axios/axios-config';
import VuetifyDialog from 'vuetify-dialog';
import Fragment from 'vue-fragment';
import Helpers from './plugins/helpers';
import Utils from './plugins/utils';
import Fvm from 'form-validation-manager';
import VueCookies from 'vue-cookies';
import VueAnalytics from 'vue-analytics';

import filterDate from '@/filters/date';
import filterNumber from '@/filters/number';

import LineEdit from './views/main/catalog/ajout-panier/ligne-commande-edition';
import CardsList from './views/main/catalog/components/cards-list';
import CardsListItemLigneCommande from './views/main/catalog/components/cards-list-item-ligne-commande';
import CardsHelp from './views/main/catalog/components/cards-help';

import GlobalComponents from '@/components/global-components.js';

import '@/assets/global.scss';
import 'vuetify-dialog/dist/vuetify-dialog.css';
import '@agrial/vue-plugin-security/dist/index.css';

Vue.config.productionTip = false;

// plugins
Vue.use(Fvm);
Vue.use(AxiosConfig);
Vue.use(SecurityPlugin, {
  router,
  store
});
Vue.use(VuetifyDialog, {
  context: { vuetify },
  undefined,
  confirm: {
    actions: {
      false: 'Non',
      true: {
        text: 'Oui',
        flat: false,
        color: 'primary'
      }
    },
    icon: false, // to disable icon just put false
    width: 500
  },
  error: {
    icon: false
  }
});
Vue.use(Fragment.Plugin);
Vue.use(Helpers);
Vue.use(Utils);
Vue.use(VueCookies);

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
});

Vue.component('LineEdit', LineEdit);
Vue.component('CardsList', CardsList);
Vue.component('CardsListItemLigneCommande', CardsListItemLigneCommande);
Vue.component('CardsHelp', CardsHelp);
Vue.use(GlobalComponents);

// filters
Vue.filter('date', filterDate.formatDate);
Vue.filter('roundNumber', filterNumber.round);
Vue.filter('splitNumber', filterNumber.split);
Vue.filter('formatDecimal', filterNumber.formatDecimal);
Vue.filter('formatInteger', filterNumber.formatInteger);
Vue.filter('roundValueIfPresent', filterNumber.roundValueIfPresent);

const vue = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

// console.log({ Vue, vue }, vue.$dialog, Vue.dialog);
// Vue.config.errorHandler = function (err, vm, info) {
//   console.log('errorHandler', err, vm, info);
//   throw err;
// };

window.addEventListener('unhandledrejection', function (event) {
  if (event.reason && event.reason.config && event.reason.request && event.reason.response) {
    // axios (http) error

    const statusTextMap = {
      400: 'Requête invalide',
      401: 'Non autorisé. Authentification requise',
      403: 'Non autorisé',
      404: 'Resource inexistante',
      409: 'Données envoyées invalides',
      500: 'Erreur technique du serveur',
      501: 'Non implémenté',
      502: 'Erreur passerelle',
      503: 'service non disponible',
      504: 'Temps d\'attente écoulé',
      999: 'Erreur inconue'
    };

    const dialogtext = [];
    dialogtext.push(event.reason.response.status + ' - ' + (statusTextMap[event.reason.response.status] || 'Erreur inconue : ' + event.reason.response.statusText));

    if (event.reason.response.data && event.reason.response.data.message) {
      dialogtext.push('Raison : ' + event.reason.response.data.message);
    }

    vue.$dialog.error({
      title: 'Erreur',
      text: dialogtext.join('<br/>'),
      actions: {
        true: {
          text: 'Fermer',
          flat: false,
          outlined: true,
          color: 'grey'
        }
      }
    });
  }
});
